class AvailableDocumentsController {
    /*@ngInject*/
    constructor($rootScope, documentActionService, sharedAjsService) {
        this.$rootScope = $rootScope;
        this.documentActionService = documentActionService;
        this.sharedAjsService = sharedAjsService;
    }
    $onInit() {
        this.savingFlag = false;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this._setFolderDetails();
        if (this.attachedDocuments.length > 0) {
            let selectedCandidateDocumentIds = [];
            let selectedJobMatchDocumentIds = [];
            this.attachedDocuments.map(doc => {
                if (doc.isJobMatchDocument) {
                    selectedJobMatchDocumentIds.push(doc.id);
                }
                else {
                    selectedCandidateDocumentIds.push(doc.id);
                }
            });
            this._setDocumentSelectionToFolders(selectedCandidateDocumentIds, selectedJobMatchDocumentIds);
        }
        else {
            this.attachedDocuments = [];
            if (this.candidateJobMatchFolders.length > 0 || this.folders.length > 0) {
                this._setDocumentSelectionToFolders(null, null);
            }
        }
    }
    _setFolderDetails() {
        this.folders = this.folders ? this.folders : [];
        if (this.candidateJobMatchFolders && this.candidateJobMatchFolders.length > 0) {
            this.candidateJobMatchFolders.map(jobMatch => {
                jobMatch.isJobMatchDocument = true;
                jobMatch.documents.map(document => {
                    document.isJobMatchDocument = true;
                });
            });
        }
        else {
            this.candidateJobMatchFolders = [];
        }
    }
    attachDocuments() {
        this.onAttachDocuments({ documents: this.attachedDocuments });
    }
    cancel() {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    }
    _setAttachedDocuments(file) {
        if (file.selected) {
            let checkIfDocExists = false;
            this.attachedDocuments.every(doc => {
                if (doc.id === file.id) {
                    checkIfDocExists = true;
                    return false;
                }
                return true;
            });
            if (!checkIfDocExists) {
                this.attachedDocuments.push(file);
            }
        }
        else {
            this.attachedDocuments = this.attachedDocuments.filter(doc => file.id != doc.id);
        }
    }
    _checkAndSetDocumentsToSelected(selectedDocumentIds, documents) {
        documents.forEach(document => {
            document.selected = (selectedDocumentIds && selectedDocumentIds.includes((document.id))) ? true : false;
        });
    }
    _checkIfAllDocumentsSelected(documents) {
        let isAllParentDocumentsSelected = true;
        documents.every(document => {
            if (!document.selected) {
                isAllParentDocumentsSelected = false;
                return false;
            }
            return true;
        });
        return isAllParentDocumentsSelected;
    }
    _setDocumentSelectionToFolders(selectedCandidateDocumentIds, selectedJobMatchDocumentIds) {
        if (this.candidateJobMatchFolders.length > 0) {
            this.candidateJobMatchFolders.map(folder => {
                if (folder.documents.length > 0) {
                    this._checkAndSetDocumentsToSelected(selectedJobMatchDocumentIds, folder.documents);
                }
            });
            this.candidateJobMatchFolders.map(folder => {
                let isAllDocumentsSelected = true;
                if (folder.documents.length > 0) {
                    isAllDocumentsSelected = this._checkIfAllDocumentsSelected(folder.documents);
                }
                folder.selected = isAllDocumentsSelected;
            });
        }
        if (this.folders.length > 0) {
            this.folders.map(parentFolder => {
                if (parentFolder.documents.length > 0) {
                    this._checkAndSetDocumentsToSelected(selectedCandidateDocumentIds, parentFolder.documents);
                }
                if (parentFolder.folders.length > 0) {
                    parentFolder.folders.map(childFolder => {
                        if (childFolder.documents.length > 0) {
                            this._checkAndSetDocumentsToSelected(selectedCandidateDocumentIds, childFolder.documents);
                        }
                    });
                }
            });
            this.folders.map(parentFolder => {
                let isAllParentDocumentsSelected = true;
                let isAllChildFolderDocumentsSelected = true;
                if (parentFolder.documents.length > 0) {
                    isAllParentDocumentsSelected = this._checkIfAllDocumentsSelected(parentFolder.documents);
                }
                if (parentFolder.folders.length > 0) {
                    parentFolder.folders.map(childFolder => {
                        if (childFolder.documents.length > 0) {
                            childFolder.selected = this._checkIfAllDocumentsSelected(childFolder.documents);
                            if (!childFolder.selected) {
                                isAllChildFolderDocumentsSelected = false;
                            }
                        }
                    });
                }
                parentFolder.selected = (!isAllChildFolderDocumentsSelected || !isAllParentDocumentsSelected) ? false : true;
            });
        }
    }
    _setAttachedDocumentsToFolders(file, folder) {
        let allDocumentsSelected = true;
        folder.documents.forEach(document => {
            if (file.id == document.id) {
                document.selected = file.selected;
            }
            if (!document.selected) {
                allDocumentsSelected = false;
            }
        });
        folder.selected = allDocumentsSelected;
        if (folder.parentFolderId) {
            this.folders.map(parentFolder => {
                if (parentFolder.id == folder.parentFolderId) {
                    if (!allDocumentsSelected) {
                        parentFolder.selected = allDocumentsSelected;
                    }
                    else {
                        let isAllParentDocumentsSelected = this._checkIfAllDocumentsSelected(parentFolder.documents);
                        parentFolder.selected = isAllParentDocumentsSelected;
                    }
                }
            });
        }
    }
    toggle(scope) {
        scope.toggle();
    }
    selectFolderWithDocuments(folder) {
        let isFolderSelected = folder.selected;
        if (folder.documents.length > 0) {
            folder.documents.forEach(document => {
                document.selected = isFolderSelected;
                this._setAttachedDocuments(document);
            });
        }
        if (folder.folders.length > 0 && folder.folders[0].documents.length > 0) {
            folder.folders[0].selected = isFolderSelected;
            folder.folders[0].documents.forEach(document => {
                document.selected = isFolderSelected;
                this._setAttachedDocuments(document);
            });
        }
        if (folder.parentFolderId) {
            let isParentFolderAllDocumentsSelected = true;
            this.folders.every(parentFolder => {
                if (parentFolder.id == folder.parentFolderId) {
                    if (parentFolder.documents.length > 0) {
                        isParentFolderAllDocumentsSelected = this._checkIfAllDocumentsSelected(parentFolder.documents);
                    }
                    parentFolder.selected = isParentFolderAllDocumentsSelected && isFolderSelected ? true : false;
                    return false;
                }
                return true;
            });
        }
    }
    getAndSetFolderToAttachedDocuments(file) {
        let folder = [];
        let folders = file.isJobMatchDocument ? this.candidateJobMatchFolders : this.folders;
        folders.map(parentFolder => {
            if (parentFolder.id === file.folderId) {
                folder = parentFolder;
            }
            else if (parentFolder.folders.length > 0) {
                parentFolder.folders.every(childFolder => {
                    if (childFolder.id == file.folderId) {
                        folder = childFolder;
                        return false;
                    }
                    return true;
                });
            }
        });
        this._setAttachedDocumentsToFolders(file, folder);
    }
    selectAndDeselectDocument(file, folder) {
        if (folder) {
            this._setAttachedDocuments(file);
            this._setAttachedDocumentsToFolders(file, folder);
        }
        else {
            file.selected = !file.selected;
            this._setAttachedDocuments(file);
            this.getAndSetFolderToAttachedDocuments(file);
        }
    }
    viewDocumentFIle(file) {
        this.sharedAjsService.viewDocumentFIle(file, (data) => {
        }, (error) => {
        });
    }
}
AvailableDocumentsController.$inject = ['$rootScope', 'documentActionService', 'sharedAjsService'];
// import * as TEMPLATE from './available-documents.html';
import * as TEMPLATE from 'raw-loader!./available-documents.html';
export const AvailableDocumentsComponent = {
    selector: 'availableDocuments',
    component: {
        bindings: {
            availableDocuments: '<',
            attachedDocuments: '<',
            folders: '<',
            candidateJobMatchFolders: '<',
            candidateId: '@',
            onAttachDocuments: '&',
            saveCallback: '&',
            cancelCallback: '&'
        },
        controller: AvailableDocumentsController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateDocuments/availableDocuments/available-documents.html'
    }
};
//# sourceMappingURL=available-documents.component.js.map